export default "__VITE_ASSET__afcdf3d5__"